import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Placeholder from '../../../components/Placeholder';
import { reducer, state } from '../../../redux/sagas/aws-cognito-redux-saga';

import {
  Anchor,
  Button,
  ButtonPlaceholder,
  Input,
  InputRow,
  InputError,
  PageContent,
  Subtitle,
  SubtitlePlaceholder,
  Text,
  Title,
  Wrapper,
  Spinner,
} from './ForgotPasswordPage.style';

const image = {
  title: 'Seminar Photo Gallery',
  description: 'Seminar Photo Gallery',
  file: {
    url:
      'https://images.ctfassets.net/qf666eyypqhw/1qanwtJ3SEuKSuiiKkIaYQ/a1f2dcc94b1ee96288c60e58dac36b19/pattern.jpg',
    details: { size: 3813, image: { width: 900, height: 1024 } },
    fileName: 'stylist_tool_login_pattern.jpg',
    contentType: 'image/jpeg',
  },
};

class ForgotPasswordPage extends Component {
  state = {
    email: '',
    loading: false,
    error: '',
    formDirty: false,
  };

  componentWillMount() {
    this.props.init();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.auth.hasSentCode === state.AUTH_UNKNOWN && nextProps.auth.hasSentCode === state.AUTH_SUCCESS) {
      this.setState({
        loading: false,
        error: '',
      });
    } else if (nextProps.auth.error && this.state.formDirty) {
      const { copy } = this.props;
      this.setState({
        loading: false,
        error: nextProps.auth.error.message
      });
    }
  }

  handleForgotPassword = e => {
    e.preventDefault();
    const { forgotPassword } = this.props;
    const { email } = this.state;
    if (this.validateForm()) {
      this.setState(
        {
          loading: true,
          formDirty: true,
        },
        () => {
          forgotPassword(email.toLowerCase());
        }
      );
    }
  };

  validateForm = () => {
    const { copy } = this.props;
    const { email } = this.state;
    if (email === '') {
      this.setState({
        loading: false,
        error: 'Please enter your email address',
      });
      return false;
    }
    this.setState({
      loading: false,
      error: '',
    });
    return true;
  };

  handleChangePassword = e => {
    e.preventDefault();
    const { history, locale } = this.props;
    history.push(`/${locale}/stylist/change-password`);
  };

  handleEmailChange = e =>
    this.setState(
      {
        email: e.target.value,
      },
      () => {
        this.validateForm();
      }
    );

  render() {
    const { locale, copy, auth } = this.props;
    const { email, loading, error } = this.state;

    return (
      <Wrapper bg={image.file.url} w={image.file.details.image.width}>
        <PageContent>
          {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
            <Title>{copy.forgot_your_password}</Title>
          ) : (
            <div>
              <Placeholder h="40px" w="500px" />
            </div>
          )}
          {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
            <Subtitle>{copy.email_you_instructions}</Subtitle>
          ) : (
            <SubtitlePlaceholder>
              <Placeholder h="24px" w="400px" />
            </SubtitlePlaceholder>
          )}
          <form
            onSubmit={auth.hasSentCode !== state.AUTH_SUCCESS ? this.handleForgotPassword : this.handleChangePassword}
          >
            <InputRow>
              <Input
                type="email"
                placeholder={copy.email_placeholder}
                value={email}
                onChange={this.handleEmailChange}
                className={error ? 'has-error' : ''}
              />
              <InputError>{error}</InputError>
            </InputRow>
            {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
              <Button type="submit" disabled={loading}>
                {loading ? (
                  <Spinner />
                ) : auth.hasSentCode !== state.AUTH_SUCCESS ? (
                  copy.send_code
                ) : (
                  copy.change_password
                ) /* eslint-disable-line */}
              </Button>
            ) : (
              <ButtonPlaceholder>
                <Placeholder h="65px" w="300px" />
              </ButtonPlaceholder>
            )}
          </form>
          {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
            <Text>
              {copy.already_have_account}
              <Link to={`/${locale}/stylist/login`} href={`/${locale}/stylist/login`}>
                <Anchor>{copy.sign_in}</Anchor>
              </Link>
            </Text>
          ) : (
            <div>
              <Placeholder h="25px" w="250px" />
            </div>
          )}
        </PageContent>
      </Wrapper>
    );
  }
}

ForgotPasswordPage.defaultProps = {
  copy: {},
};

ForgotPasswordPage.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  auth: PropTypes.shape({
    hasSentCode: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  forgotPassword: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyStylistToolForgotPasswordPage,
  locale: state.locale,
  auth: state.auth,
});

const mapDispatch = dispatch => ({
  forgotPassword: username => dispatch(reducer.forgotPassword(username)),
  init: () => dispatch(reducer.init()),
});

export default connect(mapState, mapDispatch)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/ForgotPasswordPage/ForgotPasswordPage.js